import { Drawer } from "antd";
import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";

const ErrorCommentsSlider = ({
  visible,
  onClose,
  reworkData = [],
  hasQcStatus,
  loading = false,
}) => {
  return (
    <Drawer
      title="Rework Comments"
      placement="right"
      width={530}
      onClose={onClose}
      open={visible}
      className="story-slider"
      closeIcon={<CloseCircleOutlined />}
    >
         <div className="comment-status-feed">
      {hasQcStatus
        ? reworkData.map((item, index) => (
            <div key={index} className="comment-status-entry">
              <div className="comment-avatar-background"></div>
              <div className="comment-avatar">
                {item.createdBy ? item.createdBy.charAt(0).toUpperCase() : "B"}
              </div>
              <div className="comment-entry-header">
                <div className="comment-user-info">
                  <span className="comment-user-name">
                    {item.createdBy || "User"}
                  </span>
                </div>
                <div className="comment-timestamp">
                  {item.createdOn && item.createdOn !== "0001-01-01T00:00:00"
                    ? new Date(item.createdOn).toLocaleString("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "N/A"}
                </div>
              </div>
              <p className="comment-description">
                {item.comments || "No comments available"}
              </p>

              <div className="comment-status-details">
                <div className="comment-detail-item">
                  <span className="comment-detail-label">QC Status</span>
                  <span
                    className={`comment-detail-value status-${item.qcStatus
                      ?.toLowerCase()
                      .replace(" ", "-")}`}
                  >
                    {item.qcStatus || "N/A"}
                  </span>
                </div>
                <div className="comment-detail-item">
                  <span className="comment-detail-label">Error Count</span>
                  <span className="comment-detail-value status-fail">
                    {item.errorCount || "0"}
                  </span>
                </div>
                <div className="comment-detail-item">
                  <span className="comment-detail-label">Error Category</span>
                  <span className="comment-detail-value status-fail">
                    {item.errorCategory || "N/A"}
                  </span>
                </div>
                <div className="comment-detail-item">
                  <span className="comment-detail-label">QC Actions</span>
                  <span
                    className="comment-detail-value status-fail"
                  >
                    {item.qcActions || "N/A"}
                  </span>
                </div>
              </div>
            </div>
          ))
        : reworkData.map((item, index) => (
            <div key={index} className="comment-status-entry">
              <div className="comment-avatar-background"></div>
              <div className="comment-avatar">
                {item.createdBy ? item.createdBy.charAt(0).toUpperCase() : "B"}
              </div>
              <div className="comment-entry-header">
                <div className="comment-user-info">
                  <span className="comment-user-name">
                    {item.createdBy || "Brooklyn Simmons"}
                  </span>
                </div>
                <div className="comment-timestamp">
                  {item.createdOn && item.createdOn !== "0001-01-01T00:00:00"
                    ? new Date(item.createdOn).toLocaleString("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })
                    : "08-01-2025 15:02"}
                </div>
              </div>
              <p className="comment-description">
                {item.comments ||
                        "No comments available"}
              </p>

              <div className="comment-status-single-line">
                <span className="comment-rework-station">
                  Rework Station: <strong>{item.reworkStation}</strong>
                </span>
              </div>
            </div>
          ))}
          </div>
    </Drawer>
  );
};

export default ErrorCommentsSlider;
